import React from 'react';
import MarketCard from './MarketCard';
import { useMarketContext } from '../contexts/MarketContext';

const MarketList: React.FC = () => {
  const { markets, loading, error } = useMarketContext();

  if (loading) {
    return <div className="loading">Loading markets...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  if (markets.length === 0) {
    return <div className="no-markets">No markets available.</div>;
  }

  return (
    <div className="market-list">
      {markets.map(market => (
        <MarketCard key={market.GameId} market={market} />
      ))}
    </div>
  );
}

export default React.memo(MarketList);